var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 54,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.446 2.569 6.226 12.699c.444.747 1.185 1.344 2.075 1.494l13.934 2.091c2.223.3 3.113 3.138 1.482 4.781l-10.08 9.86a2.77 2.77 0 0 0-.74 2.391l2.37 13.894c.446 2.241-1.926 4.034-4.001 2.839L11.26 46.044c-.741-.448-1.779-.448-2.52 0l-12.452 6.574c-2.075 1.046-4.298-.598-4.002-2.839l2.372-13.894a2.77 2.77 0 0 0-.741-2.39l-10.08-9.86c-1.63-1.644-.741-4.333 1.482-4.782l13.934-2.091c.89-.15 1.63-.747 2.075-1.494l6.226-12.7c.89-2.09 3.854-2.09 4.892 0z",
    fill: "#FFD41F",
    stroke: "#F4C500",
    strokeWidth: 2.023
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar6);
export default __webpack_public_path__ + "static/media/star6.edbf175e.svg";
export { ForwardRef as ReactComponent };